export default "__VITE_ASSET__Ovri_TRG__"